<template>
  <div>
    <Fontnavbar title="会员中心" />
    <div class="user-header">
      <div class="user-info">
        <van-image round width="60" height="60" :src="userInfo.head_img_path ?userInfo.head_img_path : require('../../../public/static/user_headers.png')" />
        <div>{{ userInfo.user_name }}</div>
      </div>
    </div>

    <!-- <van-row class="user-links">
      <van-col span="6">
        <van-icon name="pending-payment" @click="goorder(20,1)" />待付款
      </van-col>
      <van-col span="6">
        <van-icon name="tosend" @click="goorder(30,2)" />待发货
      </van-col>
      <van-col span="6">
        <van-icon name="logistics" @click="goorder(40,3)" />待收货
      </van-col>
      <van-col span="6">
        <van-icon name="passed" @click="goorder(60,4)" />已完成
      </van-col>
    </van-row> -->
    <div class="open_vip_warp">
      <div class="open_vip">
        <div class="vip_text">
          <div class="vip_day" v-if="userInfo.level_id == 2">
            VIP会员剩余<span>{{userInfo.day}}</span>天
          </div>
          <div class="content" v-else>
            开通VIP可享全网2000余件商品VIP价格
          </div>
        </div>
        <div class="to_open" @click="openVip">
          {{userInfo.level_id == 1? '立即开通' : '立即续费'}}
        </div>
      </div>
    </div>

    <div style="text-align: center" @click="goEnter()" v-if="userInfo.is_new">
      <van-image width="80%" :src="require('../../../public/static/enter.png')" />
    </div>

    <div class="font">
      <div class="font_one">
        <div style="padding-left:6%">请扫码或添加</div>
        <div v-if="messag" style="font-size: 16px">微信号：{{ messag.qq }}</div>
        <div>联系您的专属客服！</div>
      </div>
      <div class="font_two">
        <van-image width="120" height="120" :src="messag.wechat_img?imgDomain+messag.wechat_img:require('../../../public/static/ma.png')" />
      </div>
    </div>
    <div class="center">
      <div class="center_one">
        <div class="c_o_o">个人中心</div>
        <div class="c_o_t">
          <div @click="goorder(-1,0)">
            <van-image round width="30" height="30" :src="require('../../../public/static/all_pick.png')" />
            <div class="line">
              所有订单
            </div>

          </div>
          <!--<div @click="user_info">
                <van-image
                  round
                  width="30"
                  height="30"
                  :src="require('../../../public/static/user_mess.png')"
                />
              
                <div class="line">
                  用户信息
                </div>
              </div>-->
          <div @click="gocollect()">
            <van-image round width="30" height="30" :src="require('../../../public/static/my_collect.png')" />

            <div class="line">
              我的收藏
            </div>
          </div>
          <div @click="myserve">
            <van-image round width="30" height="30" :src="require('../../../public/static/my_serve.png')" />

            <div class="line">
              我的售后
            </div>
          </div>
        </div>
      </div>
      <div class="center_two">
        <div class="c_t_o">辅助功能</div>
        <div class="c_t_t">
          <div @click="mima">
            <van-image round width="30" height="30" :src="require('../../../public/static/pass.png')" />
            <div class="line">
              修改密码
            </div>
          </div>
          <div @click="goaddress()">
            <van-image round width="30" height="30" :src="require('../../../public/static/addres.png')" />
            <div class="line">
              地址管理
            </div>
          </div>
          <div @click="gocoupon()">
            <van-image round width="30" height="30" :src="require('../../../public/static/coupon.png')" />
            <div class="line">
              优 惠 券
            </div>
          </div>
          <div @click="fx()">
            <van-image round width="30" height="30" :src="require('../../../public/static/fx-icon.png')" />
            <div class="line">
              分销申请
            </div>
          </div>
          <!-- <div @click="govip()">
            <van-image round width="30" height="30" :src="require('../../../public/static/vip.png')" />
            <div class="line">
              会员中心
            </div>
          </div> -->
          <!--<div @click="kaifa">
                <van-image
                  round
                  width="30"
                  height="30"
                 :src="require('../../../public/static/updade.png')"
                />
                <div class="line">
                  商品更新
                </div>
              </div>-->
          <!--<div @click="kaifa">
                <van-image
                  round
                  width="30"
                  height="30"
                  :src="require('../../../public/static/sell.png')"
                />
                <div class="line">
                  申请分销
                </div>
              </div>-->
        </div>
      </div>

    </div>
    <div class="bottom">
      <div class="b_o" @click="logout">
        <van-image round width="20" height="20" :src="require('../../../public/static/eait.png')" />
      </div>
      <div class="b_t" @click="logout"> <span>退出登录</span></div>
      <div class="b_tt">
        <van-image round width="20" height="20" :src="require('../../../public/static/jiebang.png')" />
      </div>
      <div class="b_f" @click="kaifa"> <span @click="kaifa">解绑微信</span></div>

    </div>
    <div style="padding-top:20%">

    </div>
    <!-- <van-cell-group class="user-group">
      <van-cell icon="records" @click="goorder(-1,0)" title="全部订单" is-link />
    </van-cell-group>

    <van-cell-group> -->
    <!-- <van-cell icon="chat-o" title="我的评价" is-link /> -->
    <!-- <van-cell icon="star-o" @click="gocollect()" title="我的收藏" is-link />
      <van-cell icon="location-o" @click="goaddress()" title="地址管理" is-link />
      <van-cell icon="cluster-o" title="申请成为分销商" is-link />
      <van-cell icon="stop-circle-o" @click="logout" title="退出登录" is-link />
    </van-cell-group> -->

    <!-- 底部tab -->
    <TabbarBottom />
  </div>
</template>

<script>
import { logout, getUserInfo, get_customer } from "../../api.js";
import { post } from "../../request.js";
import TabbarBottom from "../../components/Tabbar.vue";
import { Toast, Loading, Icon, Image, Dialog } from "vant";
import Fontnavbar from "../../components/Navbar.vue";
export default {
  components: {
    [Toast.name]: Toast,
    [Icon.name]: Icon,
    [Loading.name]: Loading,
    [Image.name]: Image,
    TabbarBottom,
    Fontnavbar
  },
  data () {
    return {
      imgDomain: process.env.VUE_APP_IMG_URL,
      userInfo: [],
      messag: [],
    };
  },

  mounted () {
    var that = this;
    // var loading = Toast.loading({
    //   message: "加载中...",
    //   forbidClick: true,
    //   loadingType: "spinner",
    //   duration: 0
    // });
    post(getUserInfo, {}).then(res => {
      if (res.code == 200) {
        //  loading.clear();
        // 用户信息
        that.userInfo = res.data;
      } else if (res.code == 201) {
        this.$router.replace({ path: "/user/login" });
      }
    });

    post(get_customer, {}).then(res => {
      // console.log(res)
      if (res.code == 200) {
        //  loading.clear();
        that.messag = res.data;
      } else {

        // Dialog({message:res.msg})
      }
    });
    // console.log(that.messag)

  },

  methods: {
    //个人中心
    user_info () {
      this.$router.push({
        path: "/user/userinfo"
      });
    },
    // 去导购页
    goEnter(){
        this.$router.push({
            path: "/user/welcome"
        });
    },
    // 开通会员
    openVip(){
      this.$router.push({ path: '/goods/member' })
    },
    //开发中
    kaifa () {
      Dialog({ message: "开发中" })
    },
    //修改密码
    mima () {
      this.$router.push({
        path: "/user/editpwd",
        query: {
          phone: this.userInfo.phone
        }
      });
      console.log(this.userInfo.phone)
    },
    //售后
    myserve () {
      this.$router.push({
        path: "/service/servicelist",
      });
    },
    //修改密码
    pass () {
      console.log(this.messag.phone)
      this.$router.push({
        path: "/user/eaitpwd",
        query: {
          phone: this.messag.phone
        }
      });

    },
    logout () {
      Dialog.confirm({
        title: "系统提示",
        message: "您确定要退出登录吗？"
      })
        .then(() => {
          // on confirm
          post(logout, {}).then(res => {
            if (res.code == 200) {
              this.$store.dispatch("setLoginStatus", 0);
              this.$router.go(0);
            }
          });
        })
        .catch(() => {
          // on cancel
        });
    },
    goorder (order_status, active) {
      this.$router.push({
        path: "/order/order?order_status=" + order_status + "&active=" + active
      });
    },

    gocollect () {
      this.$router.push({ path: "/user/collect" });
    },

    goaddress () {
      this.$router.push({ path: "/user/address/index" });
    },
    gocoupon () {
      this.$router.push({ path: "/user/coupon/index" });
    },
    fx () {
      this.$router.push({ path: "/ad/fx" });
    },
    govip () {
      this.$router.push({ path: "/vip/apply" });
    }
  }
};
</script>

<style lang="less" scoped>
.open_vip_warp {
  padding: 0 5%;
  .open_vip {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 10px;
    margin: 20px 0 10px;
    color: #ffffff;
    border-radius: 12px;
    height: 72px;
    background: linear-gradient(to right, #2f3140, #686974);
    .vip_text {
      max-width: 68%;
      font-size: 16px;
      display: flex;
      align-items: center;
      .vip_day {
        display: flex;
        align-items: center;
        span {
          margin: 0 8px;
          font-size: 24px;
          color: #fff0d4;
        }
      }
      // .content {
      //   opacity: 0.6;
      // }
    }
    .to_open {
      padding: 0 10px;
      line-height: 28px;
      font-size: 14px;
      color: #333333;
      border-radius: 14px;
      background-color: #fff0d4;
    }
  }
}

.user {
  &-info {
    padding-top: 40px;
    text-align: center;
    font-size: 14px;
    color: #ffffff;
  }
  &-header {
    height: 160px;
    background-image: url(/static/bc_img.png);
    background-size: 100% 100%;
  }
  &-poster {
    width: 100%;
    height: 53vw;
    display: block;
  }

  &-group {
    margin-bottom: 15px;
  }

  &-links {
    padding: 15px 0;
    font-size: 12px;
    text-align: center;
    background-color: #fff;

    .van-icon {
      display: block;
      font-size: 24px;
    }
  }
}

.font {
  display: flex;
  background-color: #fff;
  margin-top: 5%;
  margin-left: 5%;
  margin-right: 5%;
  font-size: 18px;
  border-radius: 8px;
  height: 40%;
  white-space: nowrap;
}

.font_one {
  padding-left: 10%;
  margin-top: 12%;
}

.font_two {
  padding-top: 2%;
  padding-right: 5%;
  padding-left: 5%;
  padding-bottom: 2%;
}

.center_one {
  background-color: #fff;
  margin-top: 5%;
  margin-left: 5%;
  margin-right: 5%;
  border-radius: 8px;
}
.c_o_o {
  padding-top: 5%;
  margin-left: 5%;
  margin-right: 5%;
  padding-bottom: 5%;
  border-bottom: 2px solid #f4f6f8;
  border-bottom-width: 80%;
}
.c_o_t {
  display: flex;
  justify-content: space-between;
  padding-top: 5%;
  padding-left: 7%;
  padding-bottom: 7%;
}

.center_two {
  background-color: #fff;
  margin-top: 5%;
  margin-left: 5%;
  margin-right: 5%;
  border-radius: 8px;
}
.c_t_o {
  padding-top: 5%;
  margin-left: 5%;
  margin-right: 5%;
  padding-bottom: 5%;
  border-bottom: 2px solid #f4f6f8;
  border-bottom-width: 80%;
}
.c_t_t {
  display: flex;
  justify-content: space-around;
  /*justify-content: space-between;*/
  padding-top: 5%;
  padding-left: 7%;
  padding-bottom: 7%;
}
.line {
  padding-top: 20%;
  white-space: nowrap;
  font-size: 14px;
  margin-left: -24%;
}
.bottom {
  display: flex;
  margin-top: 5%;
  margin-left: 5%;
  margin-right: 5%;
  background-color: #fff;
  border-radius: 8px;
}
.b_o {
  padding-left: 8%;
  padding-top: 5%;
  padding-bottom: 5%;
}

.b_t {
  padding-left: 10%;
  padding-top: 5%;
  padding-bottom: 5%;
}

.b_t:hover {
  color: red;
}

.b_tt {
  padding-left: 10%;
  padding-top: 5%;
  padding-bottom: 5%;
}

.b_f {
  padding-left: 10%;
  padding-top: 5%;
  padding-bottom: 5%;
}

.b_f:hover {
  color: red;
}
</style>
